import type { ReactNode } from "react"

export default function PublicLayout({ children }: { children: ReactNode }) {
  return <main className="mx-auto max-w-5xl px-5 py-8">{children}</main>
}
